const AddTodoListButton = ({ onClick }) => (
  <div className="AddTodoListButton" onClick={onClick}>
    +
  </div>
);

export default AddTodoListButton;
